export enum EventConditionType {
  ReachedLevel = 'ReachedLevel',
  GlobalTime = 'GlobalTime',
  WinStreakCooldown = 'WinStreakCooldown',
  RaceEventCooldown = 'RaceEventCooldown',
}

export interface EventGlobalTimeCondition {
  type: EventConditionType.GlobalTime;
  start: number;
  end: number;
}

export interface EventLevelCondition {
  type: EventConditionType.ReachedLevel;
  level: number;
}

export interface EventWinStreakCooldownCondition {
  type: EventConditionType.WinStreakCooldown;
  cooldown: number;
}

export interface EventRaceEventCooldownCondition {
  type: EventConditionType.RaceEventCooldown;
  cooldown: number;
}

export type EventCondition =
  | EventGlobalTimeCondition
  | EventLevelCondition
  | EventWinStreakCooldownCondition
  | EventRaceEventCooldownCondition;
